@if (
    formField.isHidden ||
    (!formField.isDependant &&
        (!formField.isHidden || formField.type === fieldTypesEnum.categories || isShowHiddenFields)) ||
    (formField.isDependant &&
        (!formField.isHidden || formField.type === fieldTypesEnum.categories) &&
        formField.isShowedBecauseOfRule)
) {
    <div
        class="form-element"
        [class.form-element__small-size]="formType === formTypes.inboxSearch"
        [class.hidden-category]="formField.isHidden && formField.type === fieldTypesEnum.categories"
        [class.d-none]="formField.isHidden && !formField.isShowedBecauseOfRule && !isShowHiddenFields">
        @switch (formField.type) {
            <!-- main elements -->
            @case (fieldTypesEnum.userIdentification) {
                <sb-user-identification [formField]="formField" [formType]="formType"></sb-user-identification>
            }
            @case (fieldTypesEnum.userInfo) {
                <sb-text-input [formField]="formField"></sb-text-input>
            }
            @case (fieldTypesEnum.formHeader) {
                <sb-form-header [formField]="formField"></sb-form-header>
            }
            @case (fieldTypesEnum.sentiment) {
                <sb-sentiment [formField]="formField"></sb-sentiment>
            }
            @case (fieldTypesEnum.message) {
                <sb-message
                    [formField]="formField"
                    [activeSentimentValue]="formService.activeSentimentValue"
                    [formType]="formType"
                    [attachmentsBlockTemplate]="templateRef"
                    [attachments]="attachments">
                </sb-message>
            }
            @case (fieldTypesEnum.title) {
                <sb-title [formField]="formField"></sb-title>
            }
            @case (fieldTypesEnum.attachment) {
                <sb-attachment [formField]="formField"></sb-attachment>
            }
            @case (fieldTypesEnum.categories) {
                <sb-categories
                    appCheckCategoryValue
                    [formField]="formField"
                    [hidden]="formField.isHidden"
                    [formType]="formType">
                </sb-categories>
            }
            <!--  elements for internal forms -->
            @case (fieldTypesEnum.ccUsers) {
                <sb-cc-users [formField]="formField"></sb-cc-users>
            }
            @case (fieldTypesEnum.bccUsers) {
                <sb-cc-users [formField]="formField"></sb-cc-users>
            }
            @case (fieldTypesEnum.outboundEmailAddress) {
                <sb-outbound-email-address [formField]="formField"></sb-outbound-email-address>
            }
            @case (fieldTypesEnum.sendCopyToTheClientCheckbox) {
                <sb-send-to-client-checkbox [formField]="formField"></sb-send-to-client-checkbox>
            }
            @case (fieldTypesEnum.sendFieldsToTheClientCheckbox) {
                <sb-send-to-client-checkbox [formField]="formField"></sb-send-to-client-checkbox>
            }
            <!--  other elements -->
            @case (fieldTypesEnum.formattedText) {
                <sb-formatted-text [formField]="formField"></sb-formatted-text>
            }
            @case (fieldTypesEnum.textInput) {
                <sb-text-input [formField]="formField"></sb-text-input>
            }
            @case (fieldTypesEnum.textArea) {
                <sb-textarea [formField]="formField"></sb-textarea>
            }
            @case (fieldTypesEnum.select) {
                <sb-select [formField]="formField"></sb-select>
            }
            @case (fieldTypesEnum.region) {
                <sb-select [formField]="formField"></sb-select>
            }
            @case (fieldTypesEnum.numberInput) {
                <sb-number-input [formField]="formField"></sb-number-input>
            }
            @case (fieldTypesEnum.radio) {
                <sb-radio [formField]="formField"></sb-radio>
            }
            @case (fieldTypesEnum.checkbox) {
                <sb-checkbox [formField]="formField"></sb-checkbox>
            }
            @case (fieldTypesEnum.mobileNumber) {
                <sb-mobile-number [formField]="formField" [language]="formLanguage"></sb-mobile-number>
            }
            @case (fieldTypesEnum.address) {
                <sb-address [formField]="formField" [formType]="formType"></sb-address>
            }
            @case (fieldTypesEnum.checklist) {
                <sb-checklist [formField]="formField"></sb-checklist>
            }
            @case (fieldTypesEnum.emailInput) {
                <sb-email-input [formField]="formField"></sb-email-input>
            }
            @case (fieldTypesEnum.date) {
                <sb-date [formField]="formField"></sb-date>
            }
            @case (fieldTypesEnum.accountNumber) {
                <sb-account-number [formField]="formField"></sb-account-number>
            }
            @case (fieldTypesEnum.storeInfo) {
                <sb-store-info [formField]="formField"></sb-store-info>
            }
            @case (fieldTypesEnum.menyProductName) {
                <sb-meny-product [formField]="formField" [formType]="formType"></sb-meny-product>
            }
            @case (fieldTypesEnum.menyProductCategory) {
                <sb-meny-product-meta-field
                    [metaFieldType]="menyProductFieldEnum[menyProductFieldEnum.categoryName]"
                    [formField]="formField"
                    [formType]="formType">
                </sb-meny-product-meta-field>
            }
            @case (fieldTypesEnum.menyProductEan) {
                <sb-meny-product-meta-field
                    [metaFieldType]="menyProductFieldEnum[menyProductFieldEnum.ean]"
                    [formField]="formField"
                    [formType]="formType">
                </sb-meny-product-meta-field>
            }
            <!--  outlook elements -->
            @case (fieldTypesEnum.status) {
                <sb-ticket-status [formField]="formField"></sb-ticket-status>
            }
            @case (fieldTypesEnum.assignee) {
                <sb-assignee [formField]="formField"></sb-assignee>
            }
            @case (fieldTypesEnum.inbox) {
                <sb-community-selector [formField]="formField"></sb-community-selector>
            }
            <!--  survey elements -->
            @case (fieldTypesEnum.starRating) {
                <sb-star-rating [formField]="formField"></sb-star-rating>
            }
        }
    </div>
}
